import * as types from '../actions/action-types';

export function search(state = {query: null, apps: [], popular: []}, action) {
  switch (action.type) {
    case types.SET_SEARCH_QUERY:
      return {...state, query: action.query};

    case types.REQUEST_SEARCH:
      return {...state, isFetching: true, apps: []};

    case types.RECEIVE_SEARCH:
      return {...state, apps: action.items, receivedAt: action.receivedAt, isFetching: false};


    case types.RECEIVE_POPULAR_APPS:
      return {...state, popular: action.items, popularReceivedAt: action.receivedAt, isFetchingPopular: false};

    case types.REQUEST_POPULAR_APPS:
      return {...state, isFetchingPopular: true};

    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./reducers/search.js